<template>
  <div class="t-app__container">
    <div class="h-section h-section--no-margin-bottom">
      <div class="m-form-stepper">
        <span class="m-form-stepper__cell m-form-stepper__cell--detail m-form-stepper__cell--primary">{{ $t('create-gathering-form-title').toUpperCase() }}</span>
      </div>
    </div>

    <div class="o-ping-pong">
      <div class="h-section h-section--small">
        <div class="o-ping-pong__container">
            
          <p class="o-ping-pong__img">
            <picture>
              <source media="(min-width: 1440px)" :srcset="`${require('@/assets/images/gathering-submitted.jpg')}?mode=max&width=1400`" />
              <source media="(min-width: 1200px)" :srcset="`${require('@/assets/images/gathering-submitted.jpg')}?mode=max&width=720`" />
              <source media="(min-width: 992px)" :srcset="`${require('@/assets/images/gathering-submitted.jpg')}?mode=max&width=600`" />
              <source media="(min-width: 768px)" :srcset="`${require('@/assets/images/gathering-submitted.jpg')}?mode=max&width=490`" />
              <source media="(min-width: 568px)" :srcset="`${require('@/assets/images/gathering-submitted.jpg')}?mode=max&width=700`" />
              <source :srcset="`${require('@/assets/images/gathering-submitted.jpg')}?mode=max&width=510`" />
              <img class="a-image-responsive" :src="`${require('@/assets/images/gathering-submitted.jpg')}?mode=max&width=1600`" alt="création de rassemblement réussie" />
            </picture>
          </p>

          <div class="o-ping-pong__content h-remove-child-margin">
            <h2 class="a-title-big a-title-big--800">{{ $t('create-gathering-form-submit-title') }}</h2>
            <div class="o-ping-pong__text o-ping-pong__text--larger-height h-remove-child-margin">
              <p>{{ $t('create-gathering-form-submit-detail') }}</p>
              <p>
                <button class="a-btn-primary" type="button" @click="goToDashboard">
                  {{ $t('button-go-to-dashboard') }}
                </button>                             
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
        
    <div class="t-app__confetti t-app__confetti--01"></div>
    <div class="t-app__dot t-app__dot--large"></div>
    <div class="t-app__confetti t-app__confetti--02"></div>
    <div class="t-app__confetti t-app__confetti--04"></div>
    <div class="t-app__dot t-app__dot--medium"></div>
    <div class="t-app__confetti t-app__confetti--05"></div>

  </div>

</template>

<script>
import router from '@/router'
import { URL_USER_ORGANIZE_DASHBOARD } from '@/consts/urls'

export default {
  methods: {
    goToDashboard: function() {
      router.push({ name: URL_USER_ORGANIZE_DASHBOARD })
    }
  }
}
</script>
